import { FlowDurationSchemaWithMax, FlowDurationUnits } from 'flow-schema';
import { z } from 'zod';

import { CallbackFormFields } from './FormFields';
import { callbackDocumentationMarkdown } from './documentation';
import { type BlockConfigProps } from '../../types';

export const callbackBlockConfig: BlockConfigProps = {
  nodeHandles: [{ type: 'target' }, { type: 'source' }],
  defaultLabelPrefix: 'callback',
  defaultConfig: {
    message: '',
    waitTime: {
      value: 45,
      units: FlowDurationUnits.Seconds,
    },
    timeout: {
      value: 5,
      units: FlowDurationUnits.Minutes,
    },
  },
  configFields: {
    schema: z.object({
      message: z.string().min(1, 'Message is required'),
      waitTime: FlowDurationSchemaWithMax({
        pathName: 'value',
        max: { value: 30, units: FlowDurationUnits.Minutes },
      }),
      timeout: FlowDurationSchemaWithMax({
        pathName: 'value',
        max: { value: 1, units: FlowDurationUnits.Hours },
      }),
    }),
    FormFields: CallbackFormFields,
  },
  documentationMarkdown: callbackDocumentationMarkdown,
};
